import React from 'react';

import { Interstitialayout } from '../../molecules';
import { DefaultLayout } from '../../layouts';

const Interstitial = props => {
  return (
    <DefaultLayout interstitial={true} removePadding={true}>
      <Interstitialayout />
    </DefaultLayout>
  );
};

export default Interstitial;
